import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["serverContext", "cheggTldFrom"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import Cookie from 'cookie';
import getCookieDomain from './getCookieDomain';
/**
 * Server-side function that sets the given cookie key and value.  Optional arguments can also be
 * passed to configure cookie attributes, including domain, path, and duration.
 * @param {CookieName} name    cookie name
 * @param {string}     value   cookie value
 * @param {Object}     options cookie options
 * @returns {void}
 */
export var serverSetCookie = function serverSetCookie(name, value, options) {
  var _serverContext$res, _serverContext$res2;
  var serverContext = options.serverContext,
    cheggTldFrom = options.cheggTldFrom,
    cookieAttributes = _objectWithoutProperties(options, _excluded);
  var targetTldFrom = cheggTldFrom !== null && cheggTldFrom !== void 0 ? cheggTldFrom : serverContext;
  var setCookieString = Cookie.serialize(name, value, _objectSpread(_objectSpread({
    path: '/',
    domain: getCookieDomain(name, targetTldFrom)
  }, cookieAttributes), syncMaxAgeAndExpires(cookieAttributes.maxAge, cookieAttributes.expires)));

  /**
   * Keep other Set-Cookie headers that could be getting set. For example the
   * review cookie, which is set via server.ts
   *
   * TODO instead of modifying the response headers directly, should use a library because:
   *   Servers SHOULD NOT include more than one Set-Cookie header field in
   *   the same response with the same cookie-name.  (See Section 5.2 for
   *   how user agents handle this case.)
   * (see https://datatracker.ietf.org/doc/html/rfc6265)
   */
  var otherSetCookieStrings = ((_serverContext$res = serverContext.res) === null || _serverContext$res === void 0 ? void 0 : _serverContext$res.getHeader('Set-Cookie')) || [];
  if (!Array.isArray(otherSetCookieStrings)) {
    // getHeader could return a string if only one header set
    otherSetCookieStrings = [otherSetCookieStrings.toString()];
  }
  (_serverContext$res2 = serverContext.res) === null || _serverContext$res2 === void 0 || _serverContext$res2.setHeader('Set-Cookie', [].concat(_toConsumableArray(otherSetCookieStrings), [setCookieString]));
};

/**
 * Explicitly set maxAge and expires options to point to the same date and time.
 * (see {@link https://tools.ietf.org/html/rfc6265#section-5.3|cookie storage model specification})
 * @param {number} maxAge
 * @param {Date} expires
 * @returns
 */
export var syncMaxAgeAndExpires = function syncMaxAgeAndExpires(maxAge, expires) {
  if (maxAge === 0) {
    return {
      expires: new Date(0),
      maxAge: 0
    };
  } else if (maxAge) {
    return {
      expires: new Date(Date.now() + maxAge * 1000),
      maxAge: maxAge
    };
  } else if (expires && expires.getTime() < Date.now()) {
    return {
      expires: new Date(0),
      maxAge: 0
    };
  } else if (expires) {
    return {
      expires: expires,
      maxAge: Math.ceil((expires.getTime() - Date.now()) / 1000)
    };
  } else {
    return {};
  }
};
export default serverSetCookie;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/utils/dist/esm/cookies/serverSetCookie.js
// module id = 1261
// module chunks = 11